import { render, staticRenderFns } from "./WorkplaceStationList.vue?vue&type=template&id=2e0cb28e"
import script from "./WorkplaceStationList.vue?vue&type=script&lang=ts"
export * from "./WorkplaceStationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports